import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, Trash2, Save } from "lucide-react";
import { getAllJobs, createJob, updateJob, deleteJob } from "@/lib/api";

const EMPLOYMENT = ["Vollzeit", "Teilzeit", "Minijob", "Ausbildung"];

export const AdminJobs = () => {
  const [jobs, setJobs] = useState(null);

  const load = () => getAllJobs().then(setJobs).catch(() => setJobs([]));
  useEffect(() => { load(); }, []);

  const add = async () => {
    try {
      const job = await createJob({ title: "Neue Stelle", employment_type: "Vollzeit", location: "Dresden-Löbtau", description: "", active: true });
      setJobs((p) => [job, ...p]);
    } catch { toast.error("Anlegen fehlgeschlagen."); }
  };
  const change = (id, k, v) => setJobs((p) => p.map((j) => (j.id === id ? { ...j, [k]: v } : j)));
  const save = async (j) => {
    try {
      await updateJob(j.id, { title: j.title, employment_type: j.employment_type, location: j.location, description: j.description, active: j.active });
      toast.success("Stelle gespeichert.");
    } catch { toast.error("Speichern fehlgeschlagen."); }
  };
  const remove = async (id) => {
    try { await deleteJob(id); setJobs((p) => p.filter((j) => j.id !== id)); toast.success("Stelle gelöscht."); }
    catch { toast.error("Löschen fehlgeschlagen."); }
  };

  if (!jobs) return <div className="py-10 flex justify-center"><Loader2 className="animate-spin text-wine" /></div>;

  const inputCls = "w-full bg-white border border-wine/15 rounded px-3 py-2 text-sm focus:border-wine focus:outline-none";

  return (
    <div data-testid="admin-jobs">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-serif text-2xl text-wine">Offene Stellen</h3>
        <button onClick={add} data-testid="job-add-btn" className="inline-flex items-center gap-2 bg-wine text-cream hover:bg-wine-dark px-5 py-2.5 text-xs uppercase tracking-[0.15em] transition-colors"><Plus size={16} /> Stelle hinzufügen</button>
      </div>
      {jobs.length === 0 && <p className="text-sm text-ink-soft">Noch keine Stellen angelegt.</p>}
      <div className="space-y-5">
        {jobs.map((j) => (
          <div key={j.id} className="border border-gold/20 p-4 bg-white/60 space-y-3" data-testid={`job-edit-${j.id}`}>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <input value={j.title} onChange={(e) => change(j.id, "title", e.target.value)} placeholder="Titel" className={inputCls + " sm:col-span-1"} />
              <select value={j.employment_type} onChange={(e) => change(j.id, "employment_type", e.target.value)} className={inputCls}>
                {EMPLOYMENT.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
              <input value={j.location} onChange={(e) => change(j.id, "location", e.target.value)} placeholder="Ort" className={inputCls} />
            </div>
            <textarea value={j.description} onChange={(e) => change(j.id, "description", e.target.value)} rows={2} placeholder="Kurzbeschreibung" className={inputCls + " resize-y"} />
            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 text-xs text-ink-muted">
                <input type="checkbox" checked={!!j.active} onChange={(e) => change(j.id, "active", e.target.checked)} /> Aktiv (öffentlich sichtbar)
              </label>
              <div className="flex items-center gap-3">
                <button onClick={() => remove(j.id)} className="text-wine hover:text-wine-dark" data-testid={`job-delete-${j.id}`}><Trash2 size={16} /></button>
                <button onClick={() => save(j)} className="inline-flex items-center gap-2 bg-gold text-ink px-4 py-2 text-xs uppercase tracking-[0.15em]" data-testid={`job-save-${j.id}`}><Save size={14} /> Speichern</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
